/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { ApprovalsUserRoleSelectorContainer as ApprovalsUserRoleSelector } from './ApprovalsRoleSelector.container';
